export const RUBROS = {
  'Todos': [],
  '⚽ Deportes & Fitness': [
    'Dexter', 'Stock Center', 'Moov', 'OnSports', 'Topper', 'Reebok', 'Salomon',
    'Dash', 'Grid', 'Woker BySporting', 'Sporting', 'PuntoDeportivo', 'Factory Deportivo',
    'JJdeportes', 'NewSport', 'Templo del Futbol', 'Tienda River', 'Boca Shop',
    'NBA', 'SevenSport', 'Rossetti', 'Fila', 'Sportline', 'Atomik', 'Kappa',
    'ENA Sport', 'Star Nutrition', 'Scandinavian', 'Ferreira Sport', 'Sportotal'
  ],
  '💻 Tecnología & Electro': [
    'Sony', 'Motorola', 'Samsung', 'Musimundo', 'Cetrogar', 'Bangho', 'Fravega',
    'Whirlpool', 'Electrolux', 'SmartLife', 'Shipin', 'OnCity', 'Yelmo', 'Oster',
    'Bringeri', 'Moulinex'
  ],
  '🛒 Supermercados & Bebidas': [
    'Carrefour', 'Jumbo', 'Vea', 'Disco', 'MasOnline', 'Cordiez', 'Dia%', 'Hiper Libertad',
    'Tienda CocaCola', 'Luigibosca', 'Vinos y Spirits', 'Ferniplast', 'Gran Bazar'
  ],
  '🐕 Mascotas': [
    'Puppis', 'Natural Life'
  ],
  '🧸 Juguetes & Bebés': [
    'Cachavacha', 'Osito Azul', 'Creciendo', 'Kinderland'
  ],
  '💄 Perfumería & Farmacia': [
    'Perfumeria Rouge', 'Perfumeria Pigmento', 'Juleriaque', 'Farmacity', 'Farmaonline',
    'Farmaplus', 'Farmaquiero', 'Beauty 24', 'Rougemaison', 'Fiorani FreeShop', 'El Balcon',
    'Pandora', 'Parfumerie'
  ],
  '🏠 Hogar & Bazar': [
    'Morph', 'Blaisten', 'Familia Bercomat', 'Simmons', 'La Cardeuse', 'Easy', 'Pinturerias Garin',
    'Pinturerias Universo', 'Bergallo y Pastrone', 'Coppel', 'Arredo', 'Stanley'
  ],
  '👗 Moda & Calzado': [
    'Levis', 'Rapsodia', 'Desiderata', 'Mimo & Co', 'Taverniti', '47 street', 'XL Shop',
    '4stroke', 'Tienda Tate', 'Marathon', 'Calle M', 'Calzados Nico', 'Marea', 'Johnfoos',
    'Chelsea', 'Alpinestars', 'Exit', 'instore', 'Tienda Fuencarral', 'Cero 26',
    'Equus', 'Portsaid', 'Tommy Hilfiger', 'Crocs', 'Bowen', 'Ricky Sarkany'
  ]
};
